import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

/**
 * CARZELLE RETHEME — global Label with variants.
 * Single source of truth for label text styling across the app. Add a variant
 * here and every label site can opt in; never restyle labels inline.
 *   • default — shadcn form-control label (unchanged: text-sm font-medium)
 *   • form    — the muted form-field label LabelField already uses
 *   • field   — editorial "field key": mono, uppercase, tracked (info rows, detail views)
 */
const labelVariants = cva(
  "leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      variant: {
        default: "text-sm font-medium",
        form: "flex items-center gap-1.5 text-xs font-normal text-muted-foreground",
        field: "font-mono text-[10px] uppercase tracking-[0.1em] text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, variant, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants({ variant }), className)}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label, labelVariants }
